import "core-js/modules/es.number.constructor.js";
/**
 * Conversion of weight and height units to metric system (kg,m)
 * @param {number} value
 * @param {string} unit - unit to convert
 */
function unitConversion(value, unit) {
  var conversion = 0;
  switch (unit) {
    case 'st':
      conversion = Number(value) * 6.35029; // Stone to Kilogram
      break;
    case 'lbs':
      conversion = Number(value) * 0.453592; // Pound to Kilogram
      break;
    case 'ft':
      conversion = Number(value) * 0.3048; // Foot to Meter
      break;
    case 'in':
      conversion = Number(value) * 0.0254; // Inch to Meter
      break;
    case 'cm':
      conversion = Number(value) / 100; // Centimeter to Meter
      break;
    default:
      conversion = Number(value);
  }
  return conversion;
}

/**
 * Based on BMI, Quetelet index http://www.medical-calculator.nl/calculator/BMI/
 * @param {number} weight - weight should be on metric system (kg)
 * @param {number} height - height should be on metric system (m)
 */
function calculateBMI(weight, height) {
  if (height) {
    return weight / Math.pow(height, 2);
  }
  return 0;
}
var Calculate = {
  calculateBMI: calculateBMI,
  unitConversion: unitConversion
};
export default Calculate;